import { Mail } from 'lucide-react';
import { useState } from 'react';
import { Helmet } from 'react-helmet-async';

export function Contact() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: '',
  });

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
  };

  return (
    <>
      <Helmet>
        <title>Kontakt Oss | Aker Stadion Fanside</title>
        <meta 
          name="description" 
          content="Kontakt oss for spørsmål om Aker Stadion. Finn kontaktinformasjon, åpningstider og hvordan du kan nå oss. Uoffisiell fanside for Molde FK's hjemmearena."
        />
      </Helmet>
      <div className="min-h-screen bg-gray-100">
        <div className="bg-[#2173B9] text-white py-12">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex items-center gap-3 mb-4">
              <Mail className="w-8 h-8" />
              <h1 className="text-3xl font-bold">Contact Us</h1>
            </div>
            <p className="text-lg opacity-90">
              We're here to help you
            </p>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
            <div className="space-y-6">
              <div className="bg-white rounded-lg shadow-lg p-6">
                <h2 className="text-2xl font-bold mb-4">Contact Aker Stadium</h2>
                <p className="text-gray-600 mb-6">
                  We are the website administrators, and you can contact us only through the contact form below. 
                  We will respond to you as soon as possible.
                </p>

                <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 mb-6">
                  <p className="text-sm text-yellow-700">
                    <strong>Important:</strong> This website is an unofficial information site for Aker Stadium, 
                    and we are not affiliated with the official representatives of the stadium or Molde FK.
                  </p>
                </div>

                <h3 className="text-xl font-bold mb-3">Official Contact Information</h3>
                <div className="space-y-2 text-gray-600">
                  <p>📍 Aker Stadium, Julsundvegen 14, 6412 Molde, Norway</p>
                  <p>Email: mfk@moldefk.no</p>
                  <p>Phone: (+47) 71 20 25 00</p>
                  <p>
                    Website:{' '}
                    <a 
                      href="https://www.moldefk.no/AkerStadion" 
                      target="_blank" 
                      rel="noopener noreferrer"
                      className="text-[#2173B9] hover:underline"
                    >
                      www.moldefk.no/AkerStadion
                    </a>
                  </p>
                </div>
              </div>

              <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                <iframe
                  src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d19719.371542494955!2d7.143110729066943!3d62.73317471038867!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x4611540387baed8d%3A0x8f16e9f01e810845!2sAker%20Stadium!5e1!3m2!1sen!2sbg!4v1729850607616!5m2!1sen!2sbg"
                  width="100%"
                  height="300"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Aker Stadion Location"
                ></iframe>
              </div>
            </div>

            <div className="bg-white rounded-lg shadow-lg p-6">
              <h3 className="text-xl font-bold mb-4">Kontaktskjema</h3>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label htmlFor="name" className="block text-sm font-medium text-gray-700">
                    Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    value={formData.name}
                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-[#2173B9] focus:ring-[#2173B9]"
                    required
                  />
                </div>

                <div>
                  <label htmlFor="email" className="block text-sm font-medium text-gray-700">
                    Email
                  </label>
                  <input
                    type="email"
                    id="email"
                    value={formData.email}
                    onChange={(e) => setFormData({ ...formData, email: e.target.value })}
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-[#2173B9] focus:ring-[#2173B9]"
                    required
                  />
                </div>

                <div>
                  <label htmlFor="message" className="block text-sm font-medium text-gray-700">
                    Message
                  </label>
                  <textarea
                    id="message"
                    rows={4}
                    value={formData.message}
                    onChange={(e) => setFormData({ ...formData, message: e.target.value })}
                    className="mt-1 block w-full rounded-md border-gray-300 shadow-sm focus:border-[#2173B9] focus:ring-[#2173B9]"
                    required
                  ></textarea>
                </div>

                <button
                  type="submit"
                  className="w-full bg-[#2173B9] text-white py-2 px-4 rounded-md hover:bg-[#1b5c94] transition-colors"
                >
                  Send Message
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
